import React from 'react';

 function Preferences() {
  return(
    <h2> Hey from Preferences</h2>
  );
}


export default Preferences;